module.exports = __webpack_public_path__ + "img/hamburger-open.926526c7.svg";